<template>
  <v-app>
    <header class="top-bar">
      <div class="hamburger-logo">
        <div class="hamburger-menu" @click="toggleDrawer">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="logo" @click="setActiveTab('home')" style="cursor: pointer;">
          <img src="@/assets/logo.png" alt="MEND Logo" class="logo-image" />
        </div>
      </div>

      <div class="menu search-container">
        <input type="text" v-model="searchQuery" @input="filterResults" @focus="showDropdown = true"
          @blur="hideDropdownWithDelay" placeholder="Search MENDmate..." class="search-bar" />
        <button class="search-button" @click="searchMenus">Search</button>

        <!-- Search Dropdown (Positioned Below) -->
        <ul v-if="showDropdown && filteredMenus.length" class="search-dropdown">
          <li v-for="(menuItem, index) in filteredMenus" :key="index" @mousedown.prevent="goToPage(menuItem.link)">
            {{ menuItem.menuItem }}
          </li>
        </ul>
        
        <v-btn class="sos-btn" color="red" dark @click="setActiveTab('sos')"> SOS </v-btn>
        <v-btn icon="mdi-bell-outline" style="color: #08b6aa;" @click="goToPage('Notifications')"></v-btn>
        <v-btn icon="mdi-cog-outline" style="color: #08b6aa;" @click="goToPage('Settings')"></v-btn>
        <v-btn icon="mdi-email-outline" style="color: #08b6aa;" @click="goToPage('Inbox')"></v-btn>
        <!--<v-btn icon="mdi-account-outline" style="color: #08b6aa;" @click="goToPage('Profile')"></v-btn> -->

        <!-- Profile Dropdown -->
        <div class="text-center">
          <v-menu>
            <template v-slot:activator="{ props }">
              <v-btn v-bind="props" icon>
                <v-icon color="#08b6aa">mdi-account-outline</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="goToPage('Profile')">
                <v-list-item-title>Profile</v-list-item-title>
              </v-list-item>
              <v-list-item @click="logout">
                <v-list-item-title>Logout</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
    </header>

    <div class="menu-bar">
      <div class="menu-bar-inner">
        <a href="#" :class="{ active: activeTab === 'myPatients' }" @click.prevent="setActiveTab('myPatients')">My
          Patients</a>
        <a href="#" :class="{ active: activeTab === 'dashboard' }"
          @click.prevent="setActiveTab('dashboard')">Dashboard</a>
        <a href="#" :class="{ active: activeTab === 'patientContent' }"
          @click.prevent="setActiveTab('patientContent')">Build Therapy Plan</a>
        <a href="#" :class="{ active: activeTab === 'billing' }" @click.prevent="setActiveTab('billing')">Billing and
          Revenue</a>
        <a href="#" :class="{ active: activeTab === 'menu6' }" @click.prevent="setActiveTab('menu6')">Menu #6</a>
        <a href="#" :class="{ active: activeTab === 'menu7' }" @click.prevent="setActiveTab('menu7')">Menu #7</a>
      </div>
    </div>

    <div v-if="drawerOpen" class="side-drawer">
      <div class="drawer-header">
        <v-btn icon="mdi-arrow-left" @click="toggleDrawer" class="close-drawer"></v-btn>
      </div>
      <ul>
        <li v-for="(menuItem, index) in menus" :key="index">
          <a href="#" @click.prevent="goToPage(menuItem.link)">
            {{ menuItem.menuItem }}
          </a>
          <!-- If there are submenus, display them -->
          <ul v-if="menuItem.submenus && menuItem.submenus.length">
            <li v-for="(submenu, subIndex) in menuItem.submenus" :key="subIndex">
              <a href="#" @click.prevent="goToPage(submenu.link)">
                {{ submenu.subMenuItem }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <!-- Dashboard Widgets on Home -->
    <main class="content">
      <div v-if="activeTab === 'home'">
        <h1 class="page-title">Home</h1>

        <v-container fluid class="dashboard-container">
          <v-row>
            <!--
      <v-col cols="12" sm="6" md="4">
        <v-card class="stat-card blue-card">
          <div class="icon-container">
            <v-icon class="stat-icon">mdi-account-group</v-icon>
          </div>
          <div class="stat-content">
            <h3>Appointments</h3>
            <p class="stat-number">{{ totalAppointments }}</p>
          </div>
        </v-card>
      </v-col>-->

            <v-col cols="12" sm="6" md="4">
              <v-card class="stat-card orange-card">
                <div class="icon-container">
                  <v-icon class="stat-icon">mdi-account</v-icon>
                </div>
                <div class="stat-content">
                  <h3>Patients</h3>
                  <p class="stat-number">{{ totalPatients }}</p>
                </div>
              </v-card>
            </v-col>
            <!-- Billing & Revenue Widget -->
            <v-col cols="12" sm="6" md="4">
              <v-card class="stat-card revenue-card" @click="setActiveTab('billing')">
                <div class="icon-container">
                  <v-icon class="stat-icon">mdi-cash-multiple</v-icon>
                </div>
                <div class="stat-content">
                  <h3>Billing & Revenue</h3>
                  <p class="stat-number">${{ totalRevenue.toLocaleString() }}</p>
                  <p class="stat-subtext">Pending: ${{ pendingRevenue.toLocaleString() }}</p>
                  <p class="stat-subtext">Completed: ${{ completedRevenue.toLocaleString() }}</p>
                </div>
              </v-card>
            </v-col>
            
          <v-col cols="12" sm="6" md="4">
      <v-card class="stat-card dummy-card">
        <div class="icon-container">
          <v-icon class="stat-icon">mdi-information-outline</v-icon>
        </div>
        <div class="stat-content">
          <h3>Dummy Widget</h3>
          <p class="stat-number">Placeholder</p>
          <p class="stat-subtext">This is a test widget</p>
        </div>
      </v-card>
    </v-col>
  </v-row>
</v-container>

       <!-- Quick Actions -->
        <div class="quick-actions">
          <h3>Quick Actions</h3>
          <v-row justify="center" class="mt-2">
          <v-col cols="auto">
            <v-btn @click="setActiveTab('myPatients')">View My Patients</v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn @click="setActiveTab('patientContent')">Build Therapy Plan</v-btn>
          </v-col>
        </v-row>
        </div>
      </div>

      <!-- Dashboard Section -->
<div v-if="activeTab === 'dashboard'" class="dashboard-page">
  <h1 class="page-title">Dashboard</h1>
  <p class="page-description">
    Your key metrics and activity summary will appear here.
  </p>

  <v-row justify="center">
    <!-- Weekly Activity Bar Chart - Now in Dashboard -->
    <v-col cols="12" sm="8">
      <v-card class="chart-card">
        <h3>Weekly Patient Activity</h3>
        <WeeklyActivityChart
          :weeklyLogins="weeklyLogins"
          :completedHomework="completedHomework"
          :days="weekdays"
        />
      </v-card>
    </v-col>
  </v-row>

 <!-- <div class="dashboard-stats">
    <div class="stat-card">
      <h2>Active Patients</h2>
      <p>{{ totalPatients }}</p>
    </div>
    <div class="stat-card">
      <h2>Assignments Completed</h2>
      <p>15 This Week</p>
    </div>
    <div class="stat-card">
      <h2>Pending Assignments</h2>
      <p>10</p>
    </div>  
  </div>-->
</div>

<div v-if="activeTab === 'myPatients'">
  <h1 class="page-title">My Patients</h1>

  <!-- Expand/Collapse All Button -->
  <div class="my-patients-toggle">
    <v-btn icon @click="allExpanded = !allExpanded">
      <v-icon>{{ allExpanded ? 'mdi-arrow-collapse' : 'mdi-arrow-expand' }}</v-icon>
    </v-btn>
  </div>

  <!-- Patient Panels -->
  <div v-for="(patient, i) in patients" :key="i">
    <PatientPanel
      :patient="patient"
      :forceExpanded="allExpanded"
      @build-plan="onBuildPlan"
    />
  </div>
</div>
      <!-- Snackbar shown on login -->
<v-snackbar
  v-model="showLoginMessage"
  :timeout="5000"
  color="#ff6d44"
  elevation="3"
  location="bottom"
  class="custom-snackbar"
>
  You are logged in as a provider.
</v-snackbar>

      <div v-if="activeTab === 'sos'">
        <SOS />
      </div>

      <!-- Patient Content Section -->
      <div v-if="activeTab === 'patientContent'">
        <template v-if="$route.query.patientId">
          <ContentSelectionInsertable v-if="$route.query.patientId" @go-back="onContentSelectionGoBack"/>
        </template>
        <template v-else>
          <h1 class="page-title">Choose A Patient</h1>
          <v-select v-model="selectedPatient" :items="patientSelectionNamesList" label="Patient"></v-select>
          <template class="d-flex justify-end">
            <v-btn color="bright-orange" class="text-white" @click="setSelectedPatient" :disabled="!patientSelectionToggled">Next</v-btn>
          </template>
        </template>
      </div>
    </main>

    <!-- Billing and Revenue Section -->
    <div v-if="activeTab === 'billing'">
      <h1 class="page-title">Billing and Revenue</h1>
      <p class="page-description">This is a dummy page for Billing and Revenue. Replace this content with actual
        details.
      </p>
    </div>

    <div v-if="activeTab === 'settings'">
      <h1 class="page-title">Settings</h1>
      <p class="page-description">This is a dummy page for Settings. Replace this content with actual
        details.
      </p>
    </div>

    <div v-if="activeTab === 'profile'">
      <h1 class="page-title">Profile</h1>
      <p class="page-description">This is a dummy page for Profile. Replace this content with actual
        details.
      </p>
    </div>

    <div v-if="activeTab === 'notifications'">
      <h1 class="page-title">Notifications</h1>
      <p class="page-description">This is a dummy page for Notifications. Replace this content with actual
        details.
      </p>
    </div>

    <div v-if="activeTab === 'inbox'">
      <h1 class="page-title">Inbox</h1>
      <p class="page-description">This is a dummy page for Inbox. Replace this content with actual
        details.
      </p>
    </div>

    <!-- Menu #6 Section -->
    <div v-if="activeTab === 'menu6'">
      <h1 class="page-title">Menu #6</h1>
      <p class="page-description">This is a dummy page for Menu #6. Replace this content with actual details.</p>
    </div>

    <!-- Menu #7 Section -->
    <div v-if="activeTab === 'menu7'">
      <h1 class="page-title">Menu #7</h1>
      <p class="page-description">This is a dummy page for Menu #7. Replace this content with actual details.</p>
    </div>
  </v-app>
</template>

<script>
import axios from "axios";
import PatientPanel from "@/components/shopping-cart/PatientPanel.vue";
import WeeklyActivityChart from "@/components/shopping-cart/WeeklyActivityChart.vue";
import ContentSelectionInsertable from "./ContentSelectionInsertable.vue";
import SOS from "@/components/shopping-cart/SOS.vue";

export default {
  name: "MENDMate",
  components: {
    ContentSelectionInsertable,
    PatientPanel,
    WeeklyActivityChart,
    SOS,
  },
  data() {
    return {
      drawerOpen: false,
      patientSelectionNamesList: [],
      patientSelectionIdsList: [],
      patientSelectionToggled: false,
      popupVisible: false,
      popupTitle: "",
      popupContent: "",
      activeTab: "home", // Default tab is 'home'
      selectedPatient: "", // Stores selected patient name
      patients: [], // Patient data
      allExpanded: false,
      menus: [],
      searchQuery: "", //  Stores search input
      showDropdown: false, // Controls dropdown visibility
      totalPatients: 0,
      providerId: localStorage.getItem("providerId"),
      weeklyLogins: [ ],
      completedHomework: [ ],
      pendingHomework: [ ],
      weekdays: [],
      totalRevenue: 0,
      pendingRevenue: 0,
      completedRevenue: 0,
      isPatientsVisible: true,
      showLoginMessage: false,
    };
  },
  async mounted() {
    this.providerId = localStorage.getItem("providerId");
    const role = localStorage.getItem("userRole");
if (role === 'provider') {
    this.showLoginMessage = true;
}
  
    await this.fetchPatients();
    await this.fetchData();
    await this.fetchWeeklyActivity();
    await this.fetchRevenueData();
  },
  computed: {
    // Filters menu items dynamically (only show exact or starting matches)
    filteredMenus() {
      if (!this.searchQuery) return [];

      return this.menus.filter(menu =>
        menu.menuItem.toLowerCase().startsWith(this.searchQuery.toLowerCase())
      );
    },
  },
  methods: {
    toggleAllPatients() {
      this.allExpanded = !this.allExpanded;
    },
    onBuildPlan(queryObj){
      this.$router.push({query: queryObj});
      this.selectedPatient = "";
      this.setActiveTab('patientContent');
    },
    onContentSelectionGoBack(){
      this.$router.back();  // Remove queries 
      const origin = this.$route.query.origin; 
      if (origin && origin === "patient-panel"){
        this.setActiveTab('myPatients');
      } 
      this.selectedPatient = ""; 
    },
    async setSelectedPatient(){
      this.patientSelectionToggled = true;
      if (this.selectedPatient){
        // Post the request body for encryption of null
        console.log("Inside set selected patient");
        const response = await axios.post('/api/encryption/encrypt/array', {
          plainData: ['null'],
          headers: {
            'Content-Type': 'application/json'
          }
        });
        console.log("Next inside");

        // Get array with encrypted string for null
        const values = response.data;

        const patientIndex = this.patientSelectionNamesList.indexOf(this.selectedPatient);
        const query = {
          patientId: this.patientSelectionIdsList[patientIndex],
          planId: values[0],
          isEdit: false,
          isNew: true,
        }
        this.$router.push({query: query})
      }

      this.patientSelectionToggled = false;
    },
    async fetchPatients() {
      try {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        const response = await axios.get(`/api/patient/patients-for-provider/${this.providerId}`);
        console.log("Patients fetched:", response.data);
        this.patients = response.data;

        // Add patient to selection list for building patient content
        this.patients.forEach(patient => {
          this.patientSelectionNamesList.push(`${patient.firstName} ${patient.lastName} (${patient.email})`);
          this.patientSelectionIdsList.push(patient.encryptedPatientId);
        });
        console.log(this.patientSelectionNamesList);
        console.log(this.patientSelectionIdsList);
        
        this.totalPatients = this.patients.length;
        this.totalAppointments = this.patients.reduce((acc, patient) => acc + (patient.appointments?.length || 0), 0);
      } catch (error) {
        console.error("Error fetching patients:", error);
      }
    },

    async fetchData() {
      try {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        const response = await axios.get('/api/menu/menus-for-role?role=provider');
        this.menus = response.data;
        console.log("Menu items fetched:", this.menus);
      } catch (error) {
        console.error("Error fetching menu data:", error);
      }
    },
    async logout() {
      try {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        const response = await axios.post("/api/auth/logout", null, {
          withCredentials: true,
        });

        if (response.status === 200) {
          // Clear authentication data
          localStorage.removeItem("JwtToken");

          // Ensure Vue Router navigates to LoginPage
          this.$router.push({ name: "LoginPage" });
        } else {
          console.error(`Logout failed: ${response.statusText}`);
        }
      } catch (error) {
        console.error("Logout error:", error);
      }
    },
    getThisWeeksMonday(){
      const today = new Date();
      const dayOfWeek = today.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
      const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Adjust for Sunday
      const monday = new Date(today);
      monday.setDate(today.getDate() - daysToMonday);
      monday.setHours(0, 0, 0, 0); // Reset time to start of the day
      return monday;
    },
    async fetchWeeklyActivity() {
      try {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        const response = await axios.get(`/api/provider/engagement/${this.providerId}
        ?minDate=${this.getThisWeeksMonday().toDateString()}`);
        if (response.data && Array.isArray(response.data)) {
          // Assign API response data to the chart
          this.weeklyLogins = response.data.map((d) => d.logins || []);
          this.completedHomework = response.data.map((d) => d.completedHomework || []);
          this.weekdays = response.data.map((d) => d.weekday || []);
          console.log(this.weeklyLogins);
        } else {
          console.warn("Invalid response format for weekly activity data.");
        }
      } catch (error) {
        console.error("Error fetching weekly activity data:", error);
      }
    },
    async fetchRevenueData() {
      try {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        const response = await axios.get(`/api/billing/revenue/${this.providerId}`);

        if (response.data) {
          this.totalRevenue = response.data.totalRevenue;
          this.pendingRevenue = response.data.pendingRevenue;
          this.completedRevenue = response.data.completedRevenue;
        }
      } catch (error) {
        console.error("Error fetching revenue data:", error);
      }
    },
    //Filters results as the user types
    filterResults() {
      this.showDropdown = this.searchQuery.length > 0;
    },

    //  Search function (pressing Enter or clicking Search)
    searchMenus() {
      console.log(`Searching for: ${this.searchQuery}`);

      // If there's an exact match, navigate to it
      const exactMatch = this.menus.find(menu =>
        menu.menuItem.toLowerCase() === this.searchQuery.toLowerCase()
      );

      if (exactMatch) {
        this.goToPage(exactMatch.link);
      } else {
        console.log("No exact match found, showing dropdown results.");
      }
    },

    // Hides dropdown when clicking outside
    hideDropdown() {
      setTimeout(() => {
        this.showDropdown = false;
      }, 200);
    },


    toggleDrawer() {
      this.drawerOpen = !this.drawerOpen;
    },
    setActiveTab(tab) {
      console.log(tab)
      this.activeTab = tab; // Update active tab
    },
    goToPage(page) {
      console.log(`Navigating to ${page}`);
      if(page == 'Home'){
        if(this.drawerOpen) this.toggleDrawer()
        this.setActiveTab('home')
      }else if(page == 'CreateNewPlan' || page == 'patientcontent'){
        if(this.drawerOpen) this.toggleDrawer()
        this.setActiveTab('patientContent')
      }else if(page == 'mypatients'){
        if(this.drawerOpen) this.toggleDrawer()
        this.setActiveTab('myPatients')
      }else if(page == 'dashboard'){
        if(this.drawerOpen) this.toggleDrawer()
        this.setActiveTab('dashboard')
      }else if(page == 'billingrevenue'){
        if(this.drawerOpen) this.toggleDrawer()
        this.setActiveTab('billing')
      }else if(page == 'Settings'){
        if(this.drawerOpen) this.toggleDrawer()
        this.setActiveTab('settings')
      }else if(page == 'Profile'){
        if(this.drawerOpen) this.toggleDrawer()
        this.setActiveTab('profile')
      }else if(page == 'Notifications'){
        if(this.drawerOpen) this.toggleDrawer()
        this.setActiveTab('notifications')
      }else if(page == 'Inbox'){
        if(this.drawerOpen) this.toggleDrawer()
        this.setActiveTab('inbox')
      }else if(page == 'logout'){
        this.logout();
      }
      else{
        this.$router.push({name: page})
      }
      
    },
    showPopup(title) {
      this.popupTitle = title;
      this.popupContent = "<p>No data available.</p>";
      this.popupVisible = true;
    },
    closePopup() {
      this.popupVisible = false;
    },
  },
  watch: {
    selectedPatient(){
      this.patientSelectionToggled = (this.selectedPatient) ? true : false;
    }
  }
};
</script>

<style scoped>
/* GENERAL LAYOUT STYLES */
.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  padding: 10px 15px;
  height: 60px;
  border-bottom: 2px solid #293840;
}

.hamburger-logo {
  display: flex;
  align-items: center;
}

.hamburger-menu {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 24px;
  width: 30px;
  cursor: pointer;
}

.hamburger-menu span {
  display: block;
  height: 3px;
  width: 100%;
  background-color: #08b6aa;
  border-radius: 2px;
}

.logo {
  display: flex;
  align-items: center;
}

.logo-image {
  height: 40px;
}

.menu {
  display: flex;
  align-items: center;
  gap: 10px;
}

.search-container {
  position: relative;
  display: flex;
  align-items: center;
}

.search-bar {
  padding: 5px;
  border: 2px solid #293840;
  border-radius: 10px;
  background-color: white;
  color: #293840;
  font-size: 16px;
}

.search-button {
  padding: 5px 10px;
  background-color: #293840;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

search-dropdown {
  position: absolute;
  top: 38px;
  /* Below search bar */
  left: 0;
  width: 200px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  max-height: 150px;
  overflow-y: auto;
  z-index: 1000;
  list-style: none;
  padding: 0;
}

/* Search Dropdown Items */
.search-dropdown li {
  padding: 8px;
  cursor: pointer;
  transition: background 0.3s;
}

/* Hover effect */
.search-dropdown li:hover {
  background: #08b6aa;
  color: white;
}

.icon-button {
  background-color: white;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  /* Similar shadow effect */
}

.icon-button v-icon {
  font-size: 30px;
  /* Match icon size */
  color: #08b6aa;
  /* Consistent icon color */
}

.menu v-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #08b6aa;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  color: #08b6aa;
  background-color: white;
  margin: 0 5px;
}

.menu-bar {
  display: flex;
  justify-content: center;
  background-color: #293840;
  padding: 10px 0;
  color: white;
}

.menu-bar-inner {
  display: flex;
  justify-content: flex-start;
  gap: 20px;
}

.menu-bar a {
  margin: 0 15px;
  color: white;
  text-decoration: none;
  font-weight: 500;
}

.menu-bar-inner a.active {
  font-weight: bold;
  border-bottom: 2px solid #08b6aa;
}

/* SIDE DRAWER - SCROLLABLE */
.side-drawer {
  position: fixed;
  top: 0;
  left: 0;
  width: 250px;
  height: 100%;
  background-color: #08b6aa;
  color: white;
  padding: 20px;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.5);
  z-index: 1000;
  overflow-y: auto;
  /* Enables scrolling */
}

.drawer-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.drawer-content {
  max-height: 80vh;
  overflow-y: auto;
}

.side-drawer ul {
  list-style: none;
  padding: 0;
}

.side-drawer li {
  margin: 20px 0;
}

.side-drawer a {
  color: white;
  text-decoration: none;
  font-size: 1.2rem;
}

/* DASHBOARD STATS */
.stats-container {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
}

.stat-card {
  background-color: #08b6aa;
  color: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.dashboard-stats {
  display: flex;
  flex-direction: column;
  /* Stack cards */
  gap: 20px;
  /* Adds spacing between cards */
}

.stat-card h2 {
  margin: 0;
}

/* PAGE CONTENT */
.content {
  text-align: center;
  padding: 20px;
}

.page-title {
  font-size: 2rem;
  color: #08b6aa;
  text-align: center;
  /* Centers the text horizontally */
  margin-top: 10px;
  /* Adjusts vertical positioning */
}

.page-description {
  text-align: center;
  /* Centers the text horizontally */
  font-size: 1.2rem;
  color: #333;
}

.my-patients-toggle {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.expand-collapse-btn {
  position: relative;
  right: 0;
}

  .provider-login-snackbar {
  color: white;
  font-weight: 500;
  font-size: 1rem;
  border-radius: 10px;
  padding: 12px 20px;
  z-index: 9999;
  max-width: 300px;
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
}

/* RESPONSIVE STYLES */
@media (max-width: 768px) {
  .top-bar {
    flex-direction: row;
    justify-content: space-between;
    height: auto;
    padding: 8px;
  }

  .menu {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    margin-left: auto;
  }

  .menu v-btn {
    margin: 0 4px;
    padding: 4px;
  }

  .menu-bar {
    display: none !important;
    /* ✅ Hides the blue nav bar (tabs) on mobile */
  }

  .hamburger-menu {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 24px;
  width: 30px;
  cursor: pointer;
  padding: 5px;
  margin-right: 10px;
}

.hamburger-menu span {
  display: block;
  height: 3px;
  width: 100%;
  background-color: #08b6aa;
  border-radius: 2px;
}

  .side-drawer {
    width: 80%;
  }

  .menu-bar {
    flex-wrap: wrap;
    justify-content: center;
  }

  .menu-bar-inner {
    flex-direction: column;
    align-items: center;
  }

  .dashboard-stats {
    flex-direction: column;
    /* Stack cards on mobile */
    gap: 15px;
  }

  .stat-card {
    width: 90%;
    margin: 0 auto;
  }

  .page-title {
    font-size: 1.5rem;
  }
}

/* MODAL POPUP */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup {
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  width: 300px;
  text-align: center;
}

.popup h3 {
  margin-bottom: 15px;
}

.popup p {
  margin-bottom: 20px;
}

.close-button {
  background-color: #08b6aa;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

/* FORM STYLES */
.form-select {
  width: 100%;
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  font-size: 1rem;
  background-color: white;
  color: #293840;
}
</style>
